import { createSlice } from "@reduxjs/toolkit";
import { doChangePassword, doLogin, doLogout } from "./auth.action";
import { setHeaderAuthorization } from "../../services/api";

interface AuthState {
  token: string | null;
  loading: boolean;
  error: string | null;
  user: {
    userUniqueId: string | null;
    fullName: string | null;
    email: string | null;
    role: string | null;
  } | null;
}

const initialState: AuthState = {
  token: null,
  loading: false,
  error: null,
  user: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // login
    builder
      .addCase(doLogin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doLogin.fulfilled, (state, { payload }) => {
        const { authentication, userUniqueId, fullName, email, role } =
          payload.data;

        state.loading = false;
        state.token = authentication.accessToken;
        state.user = { userUniqueId, fullName, email, role };
        setHeaderAuthorization(authentication.accessToken);
        localStorage.setItem("token", authentication.accessToken);
        localStorage.setItem("email", email);
        sessionStorage.setItem("token", authentication.accessToken);
        sessionStorage.setItem("adminData", JSON.stringify(payload.data));
      })
      .addCase(doLogin.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload as string;
      });

    // change password
    builder
      .addCase(doChangePassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doChangePassword.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(doChangePassword.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload as string;
      });

    // logout
    builder
      .addCase(doLogout.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doLogout.fulfilled, (state) => {
        state.loading = false;
        state.user = null;
        state.error = null;
        state.token = null;
        localStorage.removeItem("token");
        localStorage.removeItem("email");
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("adminData");
        setHeaderAuthorization(null);
      })
      .addCase(doLogout.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload as string;
      });
  },
});

export default authSlice.reducer;
